import React from 'react'

const IconSchema = ({fillColor, style, ...props}) => {
  return (
   <svg {...props} xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style}  viewBox="0 -960 960 960">
       <path d="M197.12-77.12v-166.15h84.61v-153.85h-84.61v-166.15h84.61v-153.85h-84.61v-166.15h206.15v166.15h-84.62v153.85h84.62v64.62h193.85v-64.62h206.15v166.15H597.12v-64.61H403.27v64.61h-84.62v153.85h84.62v166.15H197.12Zm36.92-36.92h132.31v-92.31H234.04v92.31Zm0-320h132.31v-92.31H234.04v92.31Zm400 0h132.31v-92.31H634.04v92.31Zm-400-320h132.31v-92.31H234.04v92.31ZM300-800Zm0 320Zm400 0ZM300-160Z"/>
   </svg>
  )
}
export default IconSchema 